<template>

    <div class="dashBox">
        <div class="dashTitle">
            告警日志
        </div>

            <!-- 系统列表 -->
            <a-table :columns="columns" :data-source="tableData"  :pagination="false"  :loading="tloading" rowKey="id"
            bordered size="middle" @change="handleTableChange">
                <template slot="urlDetail" slot-scope="text">
                    <span >{{decodeURIComponent(text)}}</span>
                </template>
              
                <template slot="readParams" slot-scope="text,record">
                    <a-icon style="color:#1890ff;" :loading="expandLoading" size="large" type="file-text" @click="handleParams(record)" />
                </template>
            </a-table>
        
            <a-pagination  style="position:absolute;right:18px;bottom:18px" v-model="pagenation.current" :pageSize="pagenation.pageSize" :total="pagenation.total" @change="handlePageChange" show-less-items show-quick-jumper />
    </div>
</template>

<script>
let pagenation ={
    current:1,
    pageSize:10,
    total:0
};

const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagenation;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        },
    },
    
    {
        title: "告警名",
        dataIndex: "pos_warn_name",
        align: "center",
        ellipsis:true,

    },
    {
        title: "告警数",
        dataIndex: "errcount",
        align: "center",
        width:100,
        // sorter: true,
    },
    {
        title: "影响用户数",
        dataIndex: "usercount",
        align: "center",
        // defaultSortOrder :'descend',
        width:100,
        // sorter: true,
    },

    {
        title: "详情",
        width:50,
        scopedSlots: { customRender: 'readParams' },
        align: "center",
    },
  
];
export default {
    components:{
    },
    data () {
        return {
            tloading:false,
            pagenation,
            columns,
            tableData:[],
            sTimeRange:"",
            selectedWebSys:"",
            tempEnv:'',
            modalVisible:false,
            currentModalData:{},
            expandLoading:false,
            orderStr:' order by usercount desc'
        }
    },
    mounted(){
       
    },
    props:{

    },
    methods:{
        handleParams(item){
            localStorage.setItem('monitorweb_logs_searchp','');
 
            this.$router.push({
                path: '/monitorweb/logs',
                query:{
                    logType:'pos-warn',
                    timeRange:this.sTimeRange,
                    pos_warn_name:item.pos_warn_name
                }
            })
        },
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.orderStr = ' order by ' + sorter.field + ' ' + sorter.order.replace('end','');
            }
            else{
                this.orderStr = '';
            }
            this.loadData(null,null);

        },
       
        handlePageChange(v){
            this.pagenation.current = v
            this.loadData(null,null);
        },
        loadData(selectedEnv,selectedWebSys,sTimeRange,page){
            if(sTimeRange && selectedWebSys){
                this.sTimeRange = sTimeRange;
                this.tempEnv = selectedEnv;
                this.selectedWebSys = selectedWebSys;
            }
            if(page){
                this.pagenation.current = page
            }

            let queryStr = "* | select count(1) as errcount,count(distinct(\"__tag__:__client_ip__\")) as usercount,pos_warn_name from log "  +
            "where log_type = 'pos-warn' and project_name = '" + this.selectedWebSys + "' group by pos_warn_name" + this.orderStr;
            let that = this;
            that.tloading = true;
            let sTime = this.sTimeRange.split('~')[0];
            let eTime = this.sTimeRange.split('~')[1];
            let starttime = (new Date(sTime).getTime())/1000;
            let endtime = (new Date(eTime).getTime())/1000;
            let params = {
                projectname:'fp-zl-device',
                logstorename:this.tempEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:that.pagenation.pageSize,
                offset:(that.pagenation.current - 1) * that.pagenation.pageSize,
                reverse:false,
                paged:true,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    result.list.forEach(element => {
                        element.id = that.G.generateUUID()
                    });
                    that.tableData = result.list;
                    that.pagenation.total = parseInt(result.count);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
 

    }
}

</script>
<style scoped>

.dashBox{
        min-height: 500px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
        
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
    cursor: default;

    }


</style>
